import React from 'react';
import PropTypes from 'prop-types';
import { cx } from '../utils/cx';
import c from '../styles/controls.module.css';
import s from './ErrorBoundary.module.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(_error, _errorInfo) {
    // Optionally integrate with an error reporting service here
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={cx(c.page, s.wrapper)}>
          <div className={cx(c.panel, s.panel)}>
            <h2 className={s.title}>Something went wrong</h2>
            <p className={s.message}>We're sorry for the inconvenience. Please refresh the page.</p>
            <button
              onClick={() => window.location.reload()}
              className={cx(c.primaryButton, s.button)}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
